export const wordFive = [
  {
    id: 1,
    text: "Suicide",
    response:
      "Promoting mental wellbeing at the workplace and among teens can help reduce suicidal rates.",
  },
  {
    id: 2,
    text: "Sound",
    response: "Smiling makes us sound more confident.",
  },
  {
    id: 3,
    text: "Cadet",
    response: "National Cadet Corps was established in 1984.",
  },
  {
    id: 4,
    text: "Paranormal",
    response:
      "The lack of scientific evidence gives rise to paranormal theories.",
  },
  {
    id: 5,
    text: "Crush",
    response:
      "Our Para commandos crushed many militant launch pads during the surgical strike of 2016.",
  },
  {
    id: 6,
    text: "Disappointed",
    response:
      "We must not be disappointed if everything doesn’t go as planned in life.",
  },
  {
    id: 7,
    text: "Grumpy",
    response: "A grumpy mood can cloud our judgement.",
  },
  {
    id: 8,
    text: "Engross",
    response: "J.K. Rowling's Harry Potter is an engrossing read.",
  },
  {
    id: 9,
    text: "Skeptical",
    response: "Skepticism about life is a sign of pessimism.",
  },
  {
    id: 10,
    text: "Powerless",
    response:
      "We must not remain a powerless victim to the challenges of our life.",
  },
  {
    id: 11,
    text: "Unkind",
    response:
      "Our fate can be unkind sometimes, but we should never lose hope.",
  },
  {
    id: 12,
    text: "Sentimental",
    response:
      "National War Memorial depicts the sentimental value of the nation towards Armed Forces.",
  },
  {
    id: 13,
    text: "Nagging",
    response: "Humans tends to have nagging fear for the unknown.",
  },
  {
    id: 14,
    text: "Boundary",
    response: "Boundaries build character.",
  },
  {
    id: 15,
    text: "Whisper",
    response:
      "Whisperer are skilled in taming animals using vocal encouragement.",
  },
  {
    id: 16,
    text: "Factory",
    response:
      "Factories establishment gave a boost to the Industrial revolution providing centralized workplace.",
  },
  {
    id: 17,
    text: "Favor",
    response: "Granting a favor to the needy shows gratitude.",
  },
  {
    id: 18,
    text: "Undergraduate",
    response:
      "IISC is ranked among the top 200 universities in the world for undergraduate studies.",
  },
  {
    id: 19,
    text: "Artillery",
    response: "It is the backbone of Indian Army.",
  },
  {
    id: 20,
    text: "Engine",
    response: "The tax cut could be an engine of economic growth.",
  },
  {
    id: 21,
    text: "Armor",
    response:
      " ’Shakti’ is world’s first universal bulletproof body armor developed of Major Anoop Mishra.",
  },
  {
    id: 22,
    text: "Astronomy",
    response: "Cosmology is an important branch of Astronomy.",
  },
  {
    id: 23,
    text: "Paper",
    response:
      "We must promote Paper bags as it can reduce our reliance on polythene.",
  },
  {
    id: 24,
    text: "Qualification",
    response:
      "An intermediate qualification is necessary to join the Indian Army as an Officer.",
  },
  {
    id: 25,
    text: "Racial",
    response:
      "Racial stereotypes in our society contradict the secularism of our nation.",
  },
  {
    id: 26,
    text: "Representative",
    response:
      "Uttar Pradesh has highest number of representative in Lok Sabha.",
  },
  {
    id: 27,
    text: "Semifinal",
    response:
      "Indian Hockey Players made us proud reaching the semifinals at the Tokyo Olympics after 31 years. ",
  },
  {
    id: 28,
    text: "Silk",
    response:
      "The Silk Route was a historic trade route dated from 2nd century until the 14th century.",
  },
  {
    id: 29,
    text: "Translator",
    response:
      "Google Translate is one of the most popular online translators for many different languages.",
  },
  {
    id: 30,
    text: "Treatment",
    response:
      "Article 14 of the constitution guarantees equal treatment for everyone.",
  },
  {
    id: 31,
    text: "Flag",
    response:
      "Indian National Flag was designed by a freedom fighter named ‘Pingali Venkayya’ from Andhra Pradesh.",
  },
  {
    id: 32,
    text: "Imperfect",
    response: "Imperfections give people opportunities to grow and improve..",
  },
  {
    id: 33,
    text: "Pistol",
    response:
      "Pistol was invented by an American inventor named ‘Samuel Colt’ in 1836.",
  },
  {
    id: 34,
    text: "Fatigue",
    response: "A good nap helps overcome mental fatigue.",
  },
  {
    id: 35,
    text: "Fortify",
    response: "Exercising and healthy diet fortifies the body against illness.",
  },
  {
    id: 36,
    text: "Inventive",
    response:
      "Make in India is one of the most inventive policies to transform the manufacturing sector of this country.",
  },
  {
    id: 37,
    text: "Vibrant",
    response: "Optimism builds a vibrant personality.",
  },
  {
    id: 38,
    text: "Carbon",
    response: "It is the most abundant elements in the Universe.",
  },
  {
    id: 39,
    text: "Hymn",
    response:
      "This nation sings the hymn of praise to the sacrifices of our Armed Forces.",
  },
  {
    id: 40,
    text: "Gland",
    response:
      "An individual has between 2 and 5 million swear glands spread across the body.",
  },
  {
    id: 41,
    text: "Hill",
    response: "Plate tectonics movement leads to the formation of hills.",
  },
  {
    id: 42,
    text: "Suburb",
    response: "Mumbai has the most number of suburbs in India.",
  },
  {
    id: 43,
    text: "Human-right",
    response:
      "Human-rights violations are criminal offence in a Democratic country.",
  },
  {
    id: 44,
    text: "Commitment",
    response: "It is imperative to keep one's commitments.",
  },
  {
    id: 45,
    text: "Afghanistan",
    response: "Afghanistan is notoriously called ‘The Graveyard of Empires’.",
  },
  {
    id: 46,
    text: "Abstain",
    response:
      "It is important to abstain ourselves from adopting unethical ideologies in life.",
  },
  {
    id: 47,
    text: "Council",
    response: "Council of Ministers are headed by the PM.",
  },
  {
    id: 48,
    text: "Passage",
    response:
      "Atal Tunnel built on the Leh-Manali Highway will ensure all-weather safe passage to civilians as well as military.",
  },
  {
    id: 49,
    text: "Pledge",
    response:
      "Every citizen of this country must pledge loyalty and allegiance to the Nation.",
  },
  {
    id: 50,
    text: "Sanction",
    response:
      "Multilateral economic sanctions can be very effective against China and Pakistan.",
  },
  {
    id: 51,
    text: "Vital",
    response:
      "Physical sports should be a vital part of the school curriculum.",
  },
  {
    id: 52,
    text: "Catastrophe",
    response:
      "All countries must commit to No First Use (NFU) policy to prevent a nuclear catastrophe.",
  },
  {
    id: 53,
    text: "Viral",
    response: "Despacito is the most viral video on the internet.",
  },
  {
    id: 54,
    text: "Yell",
    response: "Yelling at children can harm their psychological well-being.",
  },
  {
    id: 55,
    text: "Device",
    response: "Smartphones are the most comprehensive device of the century.",
  },
  {
    id: 56,
    text: "Sharp",
    response: "Deserts witness sharp fall in temperature during night.",
  },
  {
    id: 57,
    text: "Gas",
    response:
      "The Bhopal Gas tragedy was the worst industrial accident in history.",
  },
  {
    id: 58,
    text: "Shooter",
    response:
      "Abhinav Bindra is the first shooter to bring an O;Olympic Gold Medal.",
  },
  {
    id: 59,
    text: "Temple",
    response:
      "Kedarnath Temple in Uttrakhand is the most visited Temple in India.",
  },
  {
    id: 60,
    text: "Mishap",
    response: "Carelessness leads to mishaps.",
  },
  {
    id: 60,
    text: "Mishap",
    response: "Carelessness leads to mishaps.",
  },
];
